import { randomUUID } from 'expo-crypto';
import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { Icon } from 'ucl/components/icon/Icon';

import { t } from 'state/intl/translations';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { CartEntryActionButton } from './cart-entry-action-button';

/* this uses maxCartQuantityMet */
export const CartEntryDuplicateButton = ({
  cartEntry,
  disabled,
}: {
  cartEntry: ICartEntry;
  disabled?: boolean;
}) => {
  const { indexedMenu } = useUnifiedMenuContext();
  const { cartEntries, addItemToMinimalCart } = useMinimalCart();
  const menuEntry = indexedMenu.find(cartEntry.id);
  const maxCartQuantity = menuEntry?.quantity?.max;
  const quantityOnCart = cartEntries.reduce(
    (acc, entry) => (entry.id === cartEntry.id ? acc + entry.quantity : acc),
    0
  );

  // TODO modify it  for oneMenu
  // const attributes = {
  //   'Product Id': cartEntry.id,
  //   'Product Name': cartEntry.name,
  //   'Edit Url': productWizardEditUrl,
  //   'Is Reorder': booleanToString(false),
  //   'Is Offer': booleanToString(isOfferCartEntry(cartEntry)),
  // };
  // logRBIProductsDetailsEvent({
  //   name: CustomEventNames.EDIT_CART,
  //   products: [cartEntry as ICartEntryLoggable],
  //   attributes,
  // });

  const handleDuplicate = () => {
    const newCartEntry = {
      ...cartEntry,
      cartId: randomUUID(),
    };
    addItemToMinimalCart(newCartEntry);
  };

  if (cartEntry.type === MinimalCartEntryType.incentive) {
    return null;
  }
  if (
    cartEntry.type === MinimalCartEntryType.reward &&
    cartEntry.children?.[0]?.type === MinimalCartEntryType.combo
  ) {
    return null;
  }
  return (
    <CartEntryActionButton
      disabled={disabled || quantityOnCart >= maxCartQuantity}
      accessibilityLabel={`${t('duplicate')} ${cartEntry.name} `}
      testID="duplicate-cart-entry-button"
      icon={<Icon name="custom:DuplicateItem" size="md" />}
      onPress={handleDuplicate}
    />
  );
};
